export default "__VITE_ASSET__CUkOZz4q__"